import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Form, Button, Row, Col, Typography } from "antd";
import { useDispatch } from "react-redux";
import {
  CustomInput,
  CustomInputPassword,
} from "../../components/utils/custom-elements/Index";
import { registerAccount, verifyAccount } from "../../thunks/user-management";
import { decrementPendingRequests, incrementPendingRequests, mobileValidator, notifySuccess } from "../../utils";
import { useRef } from "react";
import { nanoid } from "nanoid";
import LoginSignupPage from "../login/LoginSignupPage";

export default () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [reqId, setReqId] = useState();
  const otpInputRef = useRef({});

  const handleClickRegisterAccount = async () => {
    try {
      incrementPendingRequests();
      const values = await form.validateFields();
      const reqId = await registerAccount(values);
      setReqId(reqId);
      notifySuccess("OTP sent to your email address");
      otpInputRef.current?.focus();
    } finally {
      decrementPendingRequests();
    }
  };

  const handleClickVerifyAccount = async () => {
    try {
      incrementPendingRequests();
      const { otp } = await form.validateFields(["otp"]);
      await dispatch(verifyAccount(reqId, otp));
      notifySuccess("Account verified successfully");
    } finally {
      decrementPendingRequests();
    }
  };

  return (
    <LoginSignupPage>
      <div style={{ marginTop: 32, fontSize: 24, fontWeight: 300 }}>
        <span>Sign</span> <span style={{ color: "#00a1e4" }}>up</span>
      </div>
      <Form form={form} layout="vertical" style={{ marginTop: 24 }}>
        <Row gutter={16}>
          <Col sm={12}>
            <Form.Item name="fname" validateTrigger="onBlur" rules={[{ required: true }]}>
              <CustomInput
                id={`prevent_browser_autocomplete_fname_${new Date().toDateString()}`}
                autoComplete="new-password"
                required
                placeholder="First name"
                autoFocus
              />
            </Form.Item>
          </Col>
          <Col sm={12}>
            <Form.Item name="lname" validateTrigger="onBlur" rules={[{ required: true }]}>
              <CustomInput
                required
                placeholder="Last name"
                id={`prevent_browser_autocomplete_lname_${new Date().toDateString()}`}
                autoComplete="new-password"
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          name="mobile"
          validateTrigger="onBlur"
          rules={[{ required: true }, { validator: mobileValidator }]}
        >
          <CustomInput
            required
            placeholder="Mobile"
            id={`prevent_browser_autocomplete_mobile_${new Date().toDateString()}`}
            autoComplete="new-password"
          />
        </Form.Item>
        <Form.Item
          name="email"
          validateTrigger="onBlur"
          rules={[
            { required: true },
            {
              type: "email",
              message: "Provide a valid email",
            },
          ]}
        >
          <CustomInput required placeholder="Email" />
        </Form.Item>
        <Form.Item
          name="pin"
          validateTrigger="onBlur"
          rules={[
            { required: true },
            {
              validator: (_, value) => {
                if (!value) {
                  return Promise.resolve();
                }
                if (value.length !== 4) {
                  return Promise.reject("Pin should be of 4 digits");
                }
                if (isNaN(Number(value))) {
                  return Promise.reject("Pin should only contain numbers");
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <CustomInputPassword required placeholder="4 Digit Access PIN" autoComplete="new-password" />
        </Form.Item>
        {!reqId ? (
          <Button
            size="large"
            type="primary"
            htmlType="submit"
            block
            style={{ marginTop: 16 }}
            onClick={handleClickRegisterAccount}
          >
            Register account
          </Button>
        ) : (
          <>
            <Form.Item name="otp" rules={[{ required: true }]}>
              <CustomInputPassword
                id={`prevent_browser_autocomplete_${nanoid()}`}
                ref={otpInputRef}
                placeholder="OTP"
              />
            </Form.Item>
            <Button
              size="large"
              type="primary"
              htmlType="submit"
              block
              style={{ marginTop: 16 }}
              onClick={handleClickVerifyAccount}
            >
              Verify account
            </Button>
          </>
        )}
        <Typography.Paragraph
          type="secondary"
          style={{ margin: "16px 0px 0px", textAlign: "center" }}
        >
          Already registered? <Link to="/login">Login here</Link>
        </Typography.Paragraph>
      </Form>
    </LoginSignupPage>
  );
};
